// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3Ji71","dragIcon":"SortableItem_dragIcon__35A-7","disabled":"SortableItem_disabled__2gJXY"};